/*!
 * @license
 * Alfresco Example Content Application
 *
 * Copyright (C) 2005 - 2020 Alfresco Software Limited
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail.  Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with Alfresco. If not, see <http://www.gnu.org/licenses/>.
 */

import {
  InheritPermissionDirective,
  NodePermissionDialogService,
  PermissionListComponent,
} from '@alfresco/adf-content-services';
import { Node } from '@alfresco/js-api';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContentApiService } from '@alfresco/aca-shared';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationService } from '@alfresco/adf-core';

import { WkNodePermissionsDialogComponent } from '../wk-permission-dialog/wk-node-permissions.dialog';

@Component({
  selector: 'wk-permission-manager',
  templateUrl: './wk-permission-manager.component.html',
  imports: [
    TranslateModule,
    InheritPermissionDirective,
    PermissionListComponent,
  ],
  standalone: true,
})
export class WkPermissionsManagerComponent implements OnInit {
  @ViewChild('permissionList', { static: true })
  public permissionList: PermissionListComponent;

  @Input()
  public nodeId: string;

  public toggleStatus = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly contentApi: ContentApiService,
    private readonly nodePermissionDialogService: NodePermissionDialogService,
    private readonly notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.contentApi
      .getNodeInfo(this.nodeId, { include: ['permissions'] })
      .subscribe((currentNode: Node) => {
        this.toggleStatus = currentNode.permissions.isInheritanceEnabled;
      });
  }

  public onError(errorMessage: string): void {
    this.notificationService.showError(errorMessage);
  }

  public onUpdate(): void {
    this.permissionList.update.emit();
  }

  public onUpdatedPermissions(node: Node): void {
    this.toggleStatus = node.permissions.isInheritanceEnabled;
    this.permissionList.update.emit();
  }

  public openAddPermissionDialog(): void {
    this.nodePermissionDialogService
      .updateNodePermissionByDialog(this.nodeId)
      .subscribe({
        next: () => {
          this.dialog.open(WkNodePermissionsDialogComponent, {
            data: { nodeId: this.nodeId },
            panelClass: 'aca-permissions-dialog-panel',
            width: '800px',
          });
        },
        error: (error) => {
          this.notificationService.showError(error);
        },
      });
  }
}
